import { Box } from "@mui/material";
import PropTypes from "prop-types";

CopyBox.propTypes = {
  text: PropTypes.object,
};

export default function CopyBox({ text }) {
  return <Box
    component="div"
    sx={{
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      '&:hover': {
        cursor: 'copy',
      },
    }}
    onClick={() => navigator.clipboard.writeText(text)}
  >
    {text}
  </Box>;
}